import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required()
});
import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required()
});
